import {useRef, useState} from 'react';
import {useMediaQuery} from 'react-responsive';
import {useSwipeable} from 'react-swipeable';
import "./TextedBack.css";

export const TextedBack = () => {

  const [currentSlide, setSlide] = useState(1);
  const currentMobileSlide = useRef(1);
  const [carouselClasses, setCarouselClasses] = useState(['textedBlocks', 'textedDesktopCarouselInitialMove', 'textedDesktopCarouselTransition']);
  const isMobile = useMediaQuery({query: '(max-width: 800px)' });
  const isSmallBrowser = useMediaQuery({query: '(max-width: 1000px)' });

  const totalSlides = 16;
  const slidesToShow = isMobile ? 1 : isSmallBrowser ? 3 : 4;
  const carouselStartLeft = isMobile ? -85.0 : isSmallBrowser ? -33.33 : -25.0; /*-33.33;*/
  const carouselMoveLeft = isMobile ? 90.0 : isSmallBrowser ? 33.33 : 25.0;
  const [carouselLeft, setCarouselLeft] = useState( (isMobile ? -85.0 : isSmallBrowser ? -33.33 : -25.0) );
  const restartOffset = isMobile ? 5.0 : 0.0;

  const increaseCarousel = () => {
    var carousel = document.getElementById('textedDesktopCarousel');
    const maxSlide = 7;
    let newSlide = currentSlide;
    let newLeft = carouselLeft;//.current;

    if (newSlide === maxSlide + 1) {

        carousel.classList.remove('textedDesktopCarouselTransition');

        newSlide = 1;
        setSlide(newSlide);

        newLeft = carouselStartLeft;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + '%';

        let offset = carousel.offsetHeight;
        carousel.classList.add('textedDesktopCarouselTransition');

    }

    if (newSlide<totalSlides-slidesToShow) {
        newSlide++;
        setSlide(newSlide);

        /*newLeft -= carouselMoveLeft;*/
        newLeft = parseFloat(newSlide) * -carouselMoveLeft;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + "%";
        console.log(carousel);
        console.log(newLeft);
    }

  };

  const decreaseCarousel = () => {
    var carousel = document.getElementById('textedDesktopCarousel');
    const maxSlide = 7; //11;
    let newSlide = currentSlide;
    let newLeft = carouselLeft;//.current;

    if (newSlide === 1) {
        //move to end
        carousel.classList.remove('textedDesktopCarouselTransition');

        newSlide = maxSlide + 1;
        setSlide(newSlide);
        newLeft = restartOffset + (parseFloat(newSlide) * -carouselMoveLeft); //-33.33;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + '%';

        let offset = carousel.offsetHeight;

        carousel.classList.add('textedDesktopCarouselTransition');
        console.log('restarted');

    }

    if (newSlide > 0) {
        newSlide--;
        setSlide(newSlide);
        /*newLeft += carouselMoveLeft;*/ //33.33;
        newLeft = parseFloat(newSlide) * -carouselMoveLeft;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + "%";
        console.log('decreased (moved right)');
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => increaseCarousel(),
    onSwipedRight: () => decreaseCarousel(),
    preventDefaultTouchmoveEvent: true
  });




  return (
    <div className="textedBack" >
        <div className="textedBackTitle" >
        Nice things you've texted back
        </div>
        <div className="textedBlocksCarouselOuterContainer">
        <div className="textedBlocksCarouselContainer">
          <div id="textedDesktopCarousel" className={carouselClasses.join(' ')} style={{left: '-33.33' }} {...swipeHandlers} >
            {/* start with the last */}
            <div className={"textedBlock textedBackground7"} >
                <div className="textedBlockImg">
                    <img alt="Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/coffee_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;You're trying to get me to drink more coffee, aren't you?&rdquo;
                </div>
                <div className="textedBlockName" >
                Karl A., Monument CO
                </div>
            </div>


            <div className={"textedBlock textedBackground1"} >
                <div className="textedBlockImg">
                    <img alt="Red Heart" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/feedback_red_heart.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;I LOVE this service, it presents me with great beans from roasters I never would have visited otherwise.&rdquo;
                </div>
                <div className="textedBlockName" >
                -Trevor W., Portland
                </div>
            </div>

            <div className={"textedBlock textedBackground2"} >
                <div className="textedBlockImg">
                    <img alt="Red Heart Envelope" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/envelope_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Easiest way to try different coffees... it's like I'm tasting the world!&rdquo;
                </div>
                <div className="textedBlockName" >
                -Dave H., Maryland
                </div>
            </div>
            <div className={"textedBlock textedBackground3"} >
                <div className="textedBlockImg">
                    <img alt="Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/coffee_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;I love how simple the text-to-order system is: here's the coffee, how many bags? Boom.&rdquo;
                </div>
                <div className="textedBlockName" >
                -Austin P., Detroit
                </div>
            </div>
            <div className={"textedBlock textedBackground4"} >
                <div className="textedBlockImg">
                    <img alt="Yellow Heart" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/heart_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Rare finds and careful curation means that every drop is good 'till the last-well-drop.&rdquo;
                </div>
                <div className="textedBlockName" >
                -Chris V., Boston
                </div>
            </div>
            <div className={"textedBlock textedBackground5"} >
                <div className="textedBlockImg">
                    <img alt="Mailbox" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/feedback_mailbox.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Forget coffee subscriptions. One text and you get the best roasts!&rdquo;
                </div>
                <div className="textedBlockName" >
                -M Vera, Austin
                </div>
            </div>

            <div className={"textedBlock textedBackground6"} >
                <div className="textedBlockImg">
                    <img alt="Red Heart Envelope" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/envelope_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Fellow Drops is my favorite text of the week. I'm obsessed.&rdquo;
                </div>
                <div className="textedBlockName" >
                Jeff E., Redwood City
                </div>
            </div>

            <div className={"textedBlock textedBackground7"} >
                <div className="textedBlockImg">
                    <img alt="Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/coffee_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;You're trying to get me to drink more coffee, aren't you?&rdquo;
                </div>
                <div className="textedBlockName" >
                Karl A., Monument CO
                </div>
            </div>


            {/* repeat */}
            <div className={"textedBlock textedBackground1"} >
                <div className="textedBlockImg">
                    <img alt="Red Heart" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/feedback_red_heart.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;I LOVE this service, it presents me with great beans from roasters I never would have visited otherwise.&rdquo;
                </div>
                <div className="textedBlockName" >
                -Trevor W., Portland
                </div>
            </div>

            <div className={"textedBlock textedBackground2"} >
                <div className="textedBlockImg">
                    <img alt="Red Heart Envelope" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/envelope_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Easiest way to try different coffees... it's like I'm tasting the world!&rdquo;
                </div>
                <div className="textedBlockName" >
                -Dave H., Maryland
                </div>
            </div>

            <div className={"textedBlock textedBackground3"} >
                <div className="textedBlockImg">
                    <img alt="Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/coffee_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;I love how simple the text-to-order system is: here's the coffee, how many bags? Boom.&rdquo;
                </div>
                <div className="textedBlockName" >
                -Austin P., Detroit
                </div>
            </div>

            <div className={"textedBlock textedBackground4"} >
                <div className="textedBlockImg">
                    <img alt="Yellow Heart" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/heart_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Rare finds and careful curation means that every drop is good 'till the last-well-drop.&rdquo;
                </div>
                <div className="textedBlockName" >
                -Chris V., Boston
                </div>
            </div>
            <div className={"textedBlock textedBackground5"} >
                <div className="textedBlockImg">
                    <img alt="Mailbox" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/feedback_mailbox.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Forget coffee subscriptions. One text and you get the best roasts!&rdquo;
                </div>
                <div className="textedBlockName" >
                -M Vera, Austin
                </div>
            </div>

            <div className={"textedBlock textedBackground6"} >
                <div className="textedBlockImg">
                    <img alt="Red Heart Envelope" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/envelope_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;Fellow Drops is my favorite text of the week. I'm obsessed.&rdquo;
                </div>
                <div className="textedBlockName" >
                Jeff E., Redwood City
                </div>
            </div>

            <div className={"textedBlock textedBackground7"} >
                <div className="textedBlockImg">
                    <img alt="Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/coffee_feedback.png"}/>
                </div>
                <div className="textedBlockTitle" >
                &ldquo;You're trying to get me to drink more coffee, aren't you?&rdquo;
                </div>
                <div className="textedBlockName" >
                Karl A., Monument CO
                </div>
            </div>

          </div> {/* end carousel */}
        </div> {/* end carousel container */}

            <div id="carouselLeft" className={"toggle carouselLeft"} data-toggle='prev' onClick={decreaseCarousel}>
                <img alt="Left" className="carouselLeftImg" src="/images/landing/Illustrations/Various_Illustrations/black_arrow_right.svg"/>
            </div>
            <div id="carouselRight" className={"toggle carouselRight"} data-toggle='next' onClick={increaseCarousel}>
                <img alt="Right" src="/images/landing/Illustrations/Various_Illustrations/black_arrow_right.svg"/>
            </div>


        </div> {/* end outer carousel container */}
    </div>
  );
}

